/* NUOMA — galerie agrandie. Uniquement les médias visibles du coloris actif. */
(() => {
  const visiblePhotos = dialog => {
    const section = dialog.closest('[data-product-section]');
    if (!section) return [];
    return [...section.querySelectorAll('.product-gallery__item')]
      .filter(item => !item.hidden && item.getAttribute('aria-hidden') !== 'true')
      .map(item => item.querySelector('[data-nuoma-photo-zoom]'))
      .filter(Boolean);
  };
  const state = new WeakMap();
  function render(dialog, index) {
    const photos = visiblePhotos(dialog);
    if (!photos.length) { if (dialog.open) dialog.close(); return; }
    const pos = ((index % photos.length) + photos.length) % photos.length;
    state.set(dialog, pos);
    const image = dialog.querySelector('[data-nuoma-zoom-image]');
    const link = photos[pos];
    image.src = link.href;
    image.alt = link.querySelector('img')?.alt || 'Photo du produit';
    const label = dialog.querySelector('[data-nuoma-zoom-count]');
    if (label) label.textContent = `${pos + 1} / ${photos.length}`;
    dialog.querySelectorAll('[data-nuoma-zoom-prev],[data-nuoma-zoom-next]').forEach(btn => {btn.hidden = photos.length < 2;});
  }
  function open(trigger) {
    const section = trigger.closest('[data-product-section]');
    const dialog = section?.querySelector('[data-nuoma-zoom-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    const photos = visiblePhotos(dialog);
    const index = photos.indexOf(trigger);
    if (index < 0) return false;
    render(dialog, index);
    dialog.showModal();
    document.body.classList.add('nuoma-zoom-open');
    dialog.querySelector('[data-nuoma-zoom-close]')?.focus();
    return true;
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-nuoma-photo-zoom]');
    if (trigger) {
      // N'ouvrez jamais un nouvel onglet : repli seulement si <dialog> non supporté.
      if (open(trigger)) event.preventDefault();
      return;
    }
    const dialog = event.target.closest('[data-nuoma-zoom-dialog]');
    if (!dialog) return;
    if (event.target.closest('[data-nuoma-zoom-close]')) { dialog.close(); return; }
    if (event.target.closest('[data-nuoma-zoom-prev]')) { render(dialog, (state.get(dialog) || 0) - 1); return; }
    if (event.target.closest('[data-nuoma-zoom-next]')) { render(dialog, (state.get(dialog) || 0) + 1); return; }
    // Clic hors de la photo ou des boutons : fermeture de la fenêtre.
    if (event.target === dialog || event.target.classList.contains('nuoma-zoom-dialog__shell')) dialog.close();
  });
  document.addEventListener('close', event => {
    if (!event.target.matches?.('[data-nuoma-zoom-dialog]')) return;
    if (![...document.querySelectorAll('[data-nuoma-zoom-dialog]')].some(d => d.open)) {
      document.body.classList.remove('nuoma-zoom-open');
    }
  }, true);
  document.addEventListener('keydown', event => {
    const dialog = document.querySelector('[data-nuoma-zoom-dialog][open]');
    if (!dialog) return;
    if (event.key === 'ArrowLeft') { event.preventDefault(); render(dialog, (state.get(dialog) || 0) - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); render(dialog, (state.get(dialog) || 0) + 1); }
  });
  let touchStart;
  document.addEventListener('touchstart', event => {
    const dialog = event.target.closest('[data-nuoma-zoom-dialog][open]');
    if (dialog && event.touches.length === 1) touchStart = {dialog, x:event.touches[0].clientX, y:event.touches[0].clientY};
  }, {passive:true});
  document.addEventListener('touchend', event => {
    if (!touchStart || !touchStart.dialog.open || !event.changedTouches.length) return;
    const deltaX = event.changedTouches[0].clientX - touchStart.x;
    const deltaY = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.3) {
      render(touchStart.dialog, (state.get(touchStart.dialog) || 0) + (deltaX < 0 ? 1 : -1));
    }
    touchStart = null;
  }, {passive:true});
  // Lors d'un changement de coloris, évite d'afficher les anciennes photos.
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    event.target.closest('[data-product-section]')?.querySelector('[data-nuoma-zoom-dialog][open]')?.close();
  });
})();
